/* eslint-disable */
import React, { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import SuccessModal from '../../components/Modal/successModal'
//import Breadcrumbs
import { PlusOutlined } from '@ant-design/icons';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useSelector, useDispatch } from "react-redux"
import { openNotificationWithIcon } from '../../components/Modal/notification'
import { Button, Form, Input, Row, Col, Upload, Modal, Select } from 'antd';
import {
  Container
} from "reactstrap";
import { requestCompanyFromRequester } from '../../data/notificate_invite';
import * as ST from './styles'
import { getAllCompany } from '../../data/comany'
import { changeUserProfile } from '../../data/user'
import { changeUserInfo } from "../../store/actions"

const { Option } = Select
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result);

    reader.onerror = (error) => reject(error);
  });




const Projects = () => {
  const [modal_center, setmodal_center] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [fileList, setFileList] = useState([]);
  const [requestCompanyId, setRequestCompanyId] = useState();
  const [allCompanyList, setAllCompanyList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [count, setCount] = useState(0)
  const [form] = Form.useForm()

  const { currentUser } = useSelector(state => ({
    currentUser: state.Login.user
  }))
  const dispatch = useDispatch()
  useEffect(() => {
    getAllCompany().then(res => {
      setAllCompanyList(res)
    })
  }, [])
  useEffect(() => {
  setFileList([
      {
        uid: '-1',
        name: 'image.png',
        status: 'done',
        // url: `https://s3.amazonaws.com/${process.env.REACT_APP_BUCKET_NAME}/${company_info.logo}`,
        url: `${process.env.REACT_APP_URL}/company-logo/${currentUser.logo}`,
        
      }
    ])
  }, [currentUser])
  const [formModal] = Form.useForm();
  const tog_center = () => {
    setmodal_center(!modal_center)
    // removeBodyCss()
  }
  const onFinish = (values) => {
    const reData = values
    delete reData.email
    reData.id = currentUser.sub
    changeUserProfile(reData).then(res => {
      dispatch(changeUserInfo({ firstname: reData.firstname, lastname: reData.lastname, logo: reData.logo }))
      openNotificationWithIcon('success', 'Note', 'Changed your profile successfully')
    }).catch(err => {
      openNotificationWithIcon('error', 'Note', 'Failed')
    })
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  }
  const onFinishModal = values => {
    const params = {
      company_id: values.company_id,
      requester: currentUser.sub,
      requester_email: currentUser.email
    }
    requestCompanyFromRequester(params).then(() => {

    })
  }
  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  // const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
  const handleChange = async ({ fileList: newFileList }) => {
    setCount(count + 1)
    if (newFileList && newFileList.length) {
      if (count === 2) {
        const fd = new FormData();
        fd.append('img', newFileList[0].originFileObj);
        fetch(`${process.env.REACT_APP_API_URL}/upload`, {
            method: 'POST',
            body: fd,
        })
        .then(async response => {
            const data = await response.json();
            form.setFieldsValue({ logo: data.filename })
        })
        .catch(error => {
          console.log('There was an error!', error);
        });

        setCount(0)

      }
    } else {
      if (fileList[0]?.url) {
        fetch(`${process.env.REACT_APP_API_URL}/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ file: fileList[0].url.split(`${process.env.REACT_APP_URL}/company-logo/`)[1] })
        })
        .then(async response => {
            const data = await response.json();
        })
        .catch(error => {
          console.log('There was an error!', error);
        });
      }
      form.setFieldsValue({ logo: '' })
    }
    setFileList(newFileList)
  }

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload Logo
      </div>
    </div>
  );
  const handleOk = () => {
    // if (impotedUserId) {
    //   addUserToCompany({ company_id: currentUser.company_id, id: impotedUserId}).then(() => {
    //     setIsModalVisible(false);
    //     setmodal_center1(true)
    //   })
    // } else {
    //   alert('You have to choose user')
    // }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Profile | DOP Test Network</title>
        </MetaTags>
        <ST.ProfileWrapper>
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="DOP" breadcrumbItem="Profile" />
            <Form
              form={form}
              layout="vertical"
              initialValues={{ firstname: currentUser?.firstname, lastname: currentUser?.lastname, email: currentUser?.email, logo: currentUser?.logo}}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row>
                <Col span={8}></Col>
                <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Form.Item name='logo'>
                    <Upload
                      listType="picture-card"
                      fileList={fileList}
                      onPreview={handlePreview}
                      onChange={handleChange}
                    >
                      {fileList.length > 0 ? null : uploadButton}
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={8}></Col>
              </Row>
              <Row gutter={[24, 0]}>
                <Col xs={24} sm={8}></Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    label="First Name"
                    name="firstname"
                    rules={[{ required: true, message: 'Please input your firstname!' }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Last Name"
                    name="lastname"
                    rules={[{ required: true, message: 'Please input your lastname!' }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                  >
                    <Input disabled />
                  </Form.Item>
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                  >
                    <Input.Password />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}></Col>
              </Row>
              <Row>
                <Col span={8}></Col>
                <Col span={8} style={{ padding: 7 }}>
                  <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                    Save
                  </Button>
                </Col>
                <Col span={8}></Col>
              </Row>
            </Form>
          </Container>
          <SuccessModal
            title='Successfully!'
            content='Your profile updated'
            modal_center={modal_center}
            setmodal_center={setmodal_center}
            tog_center={tog_center}
          />
          <Modal visible={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
            <img
              alt="example"
              style={{
                width: '100%',
              }}
              src={previewImage}
            />
          </Modal>
        </ST.ProfileWrapper>
      </div>
    </React.Fragment>
  )
}

export default Projects;